<template>
  <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)">
    <v-toolbar elevation="0">
      <v-text-field
        flat
        outlined
        dense
        solo

        clearable
        append-icon="search"
        placeholder="Type something"
        v-model="opsitable.search"
        hide-details
        class=""
      ></v-text-field>
      <v-spacer/>
      <div class="mt-6 mr-2">
        <v-autocomplete
            clearable
            label="Category"
            @change="getProductMapping(opsitable)"
            item-text="name"
            item-value="id"
            v-model="opsitable.categoryid"
            :items="category"
        ></v-autocomplete>
      </div>
      <div class="mt-6 mr-2">
        <v-autocomplete
            clearable
            label="Brand"
            @change="getProductMapping(opsitable)"
            item-text="brandname"
            item-value="id"
            v-model="opsitable.brandid"
            :items="brands"
        ></v-autocomplete>
      </div>
      <div class="mt-6">
        <v-autocomplete
            clearable
            v-model="opsitable.sellerid"
            :items="mysupplier"
            label="Penjual"
            item-text="sellername"
            item-value="sellerid"
            dense>
          <template slot='selection' slot-scope='{ item }'>
            <div class="ma-0">{{ potongnama(item.sellername) }}</div>
          </template>
          <template slot='item' slot-scope='{ item }'>
            {{ potongnama(item.sellername) }}
          </template>
        </v-autocomplete>
      </div>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="getProductMapping(opsitable)">
        <v-icon dark>refresh</v-icon>Refresh
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      dense
      :headers="headers"
      :search="opsitable.search"
      :items="produkmapping"
      class="elevation-0"
      item-key="id"
      :options.sync="opsitable"
      :server-items-length="totalprodukmapping"
      :loading="loading"
      @update:options="getProductMapping(opsitable)">

      <template v-slot:item.price="{ item }">
        <div  class="text-right">
          {{formatAngka(item.price)}}
        </div>
      </template>
      <template v-slot:item.statustoko="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
            :color="colorStatus(item.statustoko)"
            small
            text-color="white">
            {{ tokostatustext(item.statustoko) }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.sellername="{ item }">
        <div @click="gosellerpage(item.sellerid)" style="cursor: pointer;">{{item.sellername}}</div>
      </template>
      <template v-slot:item.status="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
            :color="colorStatus(item.status)"
            small
            text-color="white">
            {{ statusText(item.status) }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.aksi="{ item }">
            <v-btn v-if="item.status==='1'"  x-small dark fab text @click.native="nonaktifkanmapping(item)" class="red ml-2">
              <v-icon small>close</v-icon>
            </v-btn>
            <v-btn v-else x-small dark fab text @click.native="aktifkanmapping(item)" class="primary ml-2">
              <v-icon small>done</v-icon>
            </v-btn>
            <v-btn x-small dark fab text @click.native="hapus(item)" class="red ml-2">
              <v-icon small>delete</v-icon>
            </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Utils from '@/plugins/utils'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import S from 'string'

export default {
  name: 'ProdukMapping',
  data: () => ({
    opsitable: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      sellerid: '',
      sortBy: ['id']
    },
    headers: [
      {
        text: 'Id',
        value: 'id'
      },
      {
        text: 'Kode',
        value: 'productcode'
      },
      {
        text: 'Produk',
        value: 'productname'
      },
      {
        text: 'Penjual',
        value: 'sellername'
      },
      {
        text: 'Status Penjual',
        value: 'statustoko'
      },
      {
        text: 'Harga',
        value: 'price'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Aksi',
        value: 'aksi'
      }
    ]
  }),
  mounted () {
    this.getMySupplier()
  },
  computed: {
    ...mapState('ProductStore', ['category', 'brands']),
    ...mapState('ProductMapping', ['overlay', 'loading', 'dialog', 'produkmapping', 'totalprodukmapping', 'mysupplier'])
  },
  methods: {
    ...mapActions('ProductMapping', ['getProductMapping', 'deleteProductMapping', 'updateProductmapping', 'getMySupplier']),
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    potongnama (val) {
      if (val.length > 20) {
        return S(val).left(20).replaceAll('`', '').s
      } else {
        return val.toUpperCase()
      }
    },
    colorStatus (val) {
      if (parseInt(val) === 1) {
        return 'green'
      } else {
        return 'red'
      }
    },
    toupper (val) {
      return val.toUpperCase()
    },
    tokostatustext (val) {
      if (val === 1) {
        return 'Buka'
      } else {
        return 'Tutup'
      }
    },
    statusText (val) {
      if (parseInt(val) === 1) {
        return 'Aktif'
      } else {
        return 'Non Aktif'
      }
    },
    hapus (val) {
      this.$confirm('Yakin akan Hapus ' + val.productname + ' ke ' + val.sellername, { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          this.deleteProductMapping(val.id)
        }
      })
    },
    aktifkanmapping (val) {
      this.$confirm('Yakin akan Aktifkan ' + val.productname + ' ke ' + val.sellername, { color: 'green', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          var a = {
            id: val.id,
            status: 1
          }
          this.updateProductmapping(a)
        }
      })
    },
    nonaktifkanmapping (val) {
      this.$confirm('Yakin akan NonAktifkan ' + val.productname + ' ke ' + val.sellername, { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          var a = {
            id: val.id,
            status: 0
          }
          this.updateProductmapping(a)
        }
      })
    },
    gosellerpage (id) {
      this.$router.push('/supplier/' + id)
    }
  }
}
</script>

<style scoped>

</style>
